import { css, styled } from "styled-components";

import { CloseIconButtonContainer } from "uikit/Buttons/CloseIconButton/styles";
import { SVG_ICON_SIZE } from "uikit/constants";
import { elementSpacingMixin } from "uikit/styles";

import { IAlertMessageContainerProps } from "./types";

export const Container = styled.div<IAlertMessageContainerProps>`
  display: flex;
  gap: 16px;
  padding: ${({ theme }) => theme.padding.p16};
  border-radius: 8px;

  ${CloseIconButtonContainer} {
    align-self: center;
  }

  ${({ $variant, theme }) => {
    switch ($variant) {
      case "info":
        return css`
          background-color: ${theme.colors.colorsNew.blue.light_blue};
        `;
      case "success":
        return css`
          background-color: ${theme.colors.colorsNew.success[100]};
        `;
      case "warning":
        return css`
          background-color: ${theme.colors.colorsNew.warning[100]};
        `;
      case "error":
        return css`
          background-color: ${theme.colors.colorsNew.error[100]};
        `;
      default:
        return css``;
    }
  }}
  ${elementSpacingMixin}
`;

export const IconContainer = styled.div<{ $variant: IAlertMessageContainerProps["$variant"] }>`
  svg {
    width: ${SVG_ICON_SIZE.large};
    height: ${SVG_ICON_SIZE.large};

    ${({ $variant }) => {
      switch ($variant) {
        case "success":
          return css`
            circle {
              stroke: none;
              fill: ${({ theme }) => theme.colors.colorsNew.success[600]};
            }
          `;
      }
    }}
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 6px;

  &:has(> *:only-child) {
    justify-content: center;
  }
`;
